<app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading > 0">
</app-mat-spinner-overlay>
<div *ngIf="usuario && usuario.sucesso" class="container" [ngClass]="usuario.retorno.aparencia">
    <div style="margin-top: 20px;">
        <ul class="breadcrumb">
            <li><strong>Onde estou:</strong></li>
            <li>
                <span id="lblSubMenu">Configuração de NFe Frota</span>
            </li>
        </ul>
        <div class="panel panel-default form-filtrar form-default">
            <div class="panel-body">
                <div class="row">
                    <div class="col-md-9 form-group">
                        <app-filtro-frota (onFrotaSelected)="selecionaFrota($event)"></app-filtro-frota>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="codigoFrota">
            <mat-tab-group>
                <mat-tab label="Reagendamento">
                    <form (ngSubmit)="onSubmitReagendamento(f)" name="reagendamento" #f="ngForm">
                        <div class="panel panel-info" *ngIf="parametroReagendamento">
                            <div class="panel-body">
                                <div class="row mt-4">
                                    <div class="col-md-4 form-group">
                                        <label class='center-block'>
                                            Habilitado
                                        </label>
                                        <mat-radio-group value="" aria-label="Selectione uma opção"
                                            name="flagReagendamentoHabilitado"
                                            [(ngModel)]="parametroReagendamento.habilitado"
                                            (ngModelChange)="onChangeReagendamentoHabilitado($event)"
                                            matTooltip="Habilita o sistema de Reagendamento na Frota, obrigando os postos a realizarem o upload de NFe.">
                                            <mat-radio-button value="S" class="radio-filtro">SIM</mat-radio-button>
                                            <mat-radio-button value="N" class="radio-filtro">NÃO</mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                    <div class="col-md-4 form-group">
                                        <label class='center-block'>
                                            Data Início para Upload
                                        </label>
                                        <div class="input-group">
                                            <input type="date" class="form-control"
                                                name="dataInicioOperacaoReagendamento"
                                                [(ngModel)]="parametroReagendamento.dataInicioOperacao"
                                                [disabled]="parametroReagendamento.habilitado == 'N'"
                                                [required]="parametroReagendamento.habilitado == 'S'"
                                                #dataInicioOperacaoReagendamento="ngModel">
                                        </div>
                                        <div [hidden]="parametroReagendamento.habilitado == 'N' || (dataInicioOperacaoReagendamento.valid || (dataInicioOperacaoReagendamento.pristine && !f.submitted))"
                                            style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                            <span>Informe a Data de Início de Operação !</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4 form-group">
                                        <label class='center-block'>
                                            Data Início Reagendamento
                                        </label>
                                        <div class="input-group">
                                            <input type="date" class="form-control" name="dataInicioReagendamento"
                                                [(ngModel)]="parametroReagendamento.dataInicioReagendamento"
                                                [disabled]="parametroReagendamento.habilitado == 'N'"
                                                #dataInicioReagendamento="ngModel">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4 form-group">
                                        <label class='center-block'>
                                            Modalidade
                                        </label>
                                        <mat-radio-group value="" aria-label="Selectione uma opção"
                                            name="flagReagendamentoModalidade"
                                            [(ngModel)]="parametroReagendamento.tipoReagendamento"
                                            (ngModelChange)="parametroReagendamento.qtdeDiasAposFechamentoCiclo = null;"
                                            [disabled]="parametroReagendamento.habilitado == 'N'"
                                            [required]="parametroReagendamento.habilitado == 'S'">
                                            <mat-radio-button value="1" class="radio-filtro">(Data de crédito / Data de
                                                Débito)
                                                - 3
                                                dias</mat-radio-button>
                                            <mat-radio-button value="2" class="radio-filtro">Data de Fechamento + x
                                                dias</mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                    <div class="col-md-4 form-group">
                                        <label class='center-block'>
                                            Quantidade de dias após Fechamento
                                        </label>
                                        <div class="input-group">
                                            <input type="text" class="form-control" name="qtdeDiasReagendamento"
                                                [(ngModel)]="parametroReagendamento.qtdeDiasAposFechamentoCiclo"
                                                [disabled]="parametroReagendamento.habilitado == 'N' || parametroReagendamento.tipoReagendamento == '1'"
                                                [required]="parametroReagendamento.habilitado == 'S' && parametroReagendamento.tipoReagendamento == '2'"
                                                #qtdeDiasReagendamento="ngModel">
                                        </div>
                                        <div [hidden]="(parametroReagendamento.habilitado == 'N' || parametroReagendamento.tipoReagendamento == '1')  || (qtdeDiasReagendamento.valid || (qtdeDiasReagendamento.pristine && !f.submitted))"
                                            style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                                            <span>Informe a quantidade de dias após o Fechamento !</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-5">
                                    <div class="col-md-4 form-group" style="display: inline-block;">
                                        <button id="alterarReagendamento" type="submit"
                                            class="btn btn-primary btn-submit">
                                            <i class="fa fa-copy"></i>Alterar Reagendamento
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </mat-tab>
                <mat-tab label="Conciliação">
                    <div class="panel panel-info" *ngIf="parametroConciliacao">
                        <div class="panel-body">
                            <div class="row mt-4">
                                <div class="col-md-4 form-group">
                                    <label class='center-block'>
                                        Modalidade
                                    </label>
                                    <mat-radio-group value="" aria-label="Selectione uma opção"
                                        name="flagConciliacaoModalidade"
                                        matTooltip="Define o tipo de conciliação a ser explicado quando a NFe for recebida pela Arquivei ou Email."
                                        [(ngModel)]="parametroConciliacao.tipoConciliacao"
                                        (ngModelChange)="parametroConciliacao.valorFixoAceite = null;">
                                        <mat-radio-button value="E" class="radio-filtro">Exata por
                                            Valor</mat-radio-button>
                                        <mat-radio-button value="C" class="radio-filtro">Aceita conciliação por
                                            Volume</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label class='center-block'>
                                        Tolerância de valor para conciliação exata
                                    </label>
                                    <input currencyMask type="text" id="tolerancia" name="tolerancia" autofocus="true"
                                        placeholder="R$ 0,00" [(ngModel)]="parametroConciliacao.valorFixoAceite"
                                        maxlength="9"
                                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2 }"
                                        [disabled]="parametroConciliacao.tipoConciliacao == 'C'"
                                        [required]="parametroConciliacao.tipoConciliacao == 'E'">
                                </div>
                                <div class="col-md-4 form-group">
                                    <label class='center-block'>
                                        Emissão de NFe por UF
                                    </label>
                                    <mat-radio-group value="" aria-label="Selectione uma opção"
                                        name="flagEmissaoUF"
                                        matTooltip="Define se a frota necessita ou não da emissão de NFe por UF."
                                        [(ngModel)]="parametroConciliacao.flagEmissaoUF">
                                        <mat-radio-button value="S" class="radio-filtro">SIM</mat-radio-button>
                                        <mat-radio-button value="N" class="radio-filtro">NÃO</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <div class="row mt-5">
                                <div class="col-md-4 form-group" style="display: inline-block;">
                                    <button id="alterarConciliacao" type="button" class="btn btn-primary"
                                        (click)="alterarParametroConciliacao()">
                                        <i class="fa fa-copy"></i>Alterar Conciliação
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Arquivei">
                    <div class="panel panel-info" *ngIf="arquivei">
                        <div class="panel-body">
                            <div class="row mt-4">
                                <div class="col-md-4 form-group">
                                    <label class='center-block'>
                                        Habilitado
                                    </label>
                                    <input type="text" class="form-control" name="codigoFrota"
                                        [value]="arquivei.flagAceite == 1 ? 'SIM':'NÃO'" [disabled]="true">
                                </div>
                                <div class="col-md-4 form-group">
                                    <label class='center-block'>
                                        Login Aceite
                                    </label>
                                    <input type="text" class="form-control" name="loginAceite"
                                        [value]="arquivei.loginAceite" [disabled]="true">
                                </div>
                                <div class="col-md-4 form-group">
                                    <label class='center-block'>
                                        Data Aceite
                                    </label>
                                    <input type="text" class="form-control" name="dataAceite"
                                        [value]="arquivei.dataAceite" [disabled]="true">
                                </div>
                            </div>
                            <div class="row mt-5">
                                <div class="col-md-4 form-group" style="display: inline-block;">
                                    <button id="cancelarArquivei" type="button" class="btn btn-primary"
                                        [disabled]="arquivei.flagAceite == 0" (click)="cancelarArquivei()">
                                        <i class="fa fa-copy"></i>Cancelar Arquivei
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>